export default "__VITE_ASSET__BP_6U7jc__"